<template>
    <div id="page-nodes-details">
      <nodes-form
          v-model="model"
          ref="form"
          :loading="loading"
          card-title="Create Nodes"
      />
  
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
              @click="$router.push({ name: 'content-management.nodes.list' })"
              class="mr-4 my-4"
            >
              Cancel
            </vs-button>
            <vs-button
                v-if="componentAccess.canPublish.access && model"
                class="mr-4 my-4"
                color="light"
                @click="openEnableAlert(model)"
            >
              {{ model.IsEnabled ? "Deactivate" : "Activate" }}
            </vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
              :disabled="loading"
              @click="update"
              class="my-4"
              color="light"
            >
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  
  import NodesForm from "@/views/pages/content-management/nodes/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  import ViewModelMixin from "@/components/mixins/ViewModelMixin";
  import SaveModelMixin from '@/components/mixins/SaveModelMixin';
  import EnablePublishMixin from '@/components/mixins/EnablePublishMixin';
  import CanAccessMixin from '@/components/mixins/CanAccessMixin';
  
  export default {
    name: "NewsEdit",
    components: {
      NodesForm
    },
    mixins: [ViewModelMixin, NotificationMixin, SaveModelMixin, EnablePublishMixin, CanAccessMixin],
    data() {
      return {
        model: {},
        loading: false,
        modelEntity: this.$api.contentManagementNodes,
        componentAccess: {
          canPublish: {
            route: 'content-management.nodes.publish',
            access: false,
          },
        },
      };
    },
    methods: {
    async fetch(id) {
      if (!this.modelEntity || !id) {
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch('updateIsLoading', true);
        const {
          data
        } = await this.modelEntity.get(id);
        
        this.model = {
          ...data.data,
        };

        await this.$store.dispatch('updateIsDeleted', this.model.IsDeleted || false);
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        await this.$store.dispatch('updateIsLoading', false);
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'Parent_CommercialProductNode_FK',
          'Localization_FK',
        ]
        
        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async update() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();
        console.log(params);
        //  return;
        try {
          const {data} = await this.$api.contentManagementNodes.update(this.id, params);
          this.notifySuccess('Node updated');
          this.$router.back();
        } catch (e) {
          this.notifyError('Update failed');
          console.error(e)
        } finally {
        }
      }
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  